export default "/_nuxt/e7ab9703f6ad8bd783f6a41efe98aadd.svg";